// extracted by mini-css-extract-plugin
export var aiBadge = "recipe-content-module--ai-badge--cd95a";
export var container = "recipe-content-module--container--007d1";
export var content = "recipe-content-module--content--251fa";
export var fullRatioClass = "recipe-content-module--full-ratio-class--ea7df";
export var header = "recipe-content-module--header--dc979";
export var img = "recipe-content-module--img--a41a9";
export var imgBox = "recipe-content-module--img-box--c5214";
export var ingredientList = "recipe-content-module--ingredient-list--56747";
export var simple = "recipe-content-module--simple--8b488";
export var simpleRatioClass = "recipe-content-module--simple-ratio-class--228ae";
export var stepList = "recipe-content-module--step-list--bc61d";
export var video = "recipe-content-module--video--76eae";